import { screenRulesQueryOptions } from '../../../rules';
import type { WarmUp } from '../../../routes/warmRoutes';
import { directoryFiltersOf, plantPeopleFiltersOf } from '../domain/peopleFilters';

import {
  catalogueQueryOptions,
  licencesQueryOptions,
  peopleInfiniteQueryOptions,
  permissionTemplatesQueryOptions,
  personQueryOptions,
  templatesQueryOptions,
} from './queryOptions';

export const warmUserCenter: WarmUp = ({ queryClient }) => {
  void queryClient.prefetchQuery(screenRulesQueryOptions());
};

export const warmPeopleDirectory: WarmUp = ({ queryClient, searchParams }) => {
  const filters = directoryFiltersOf(searchParams.get('q') ?? '', searchParams.get('plant') ?? '');
  void queryClient.prefetchInfiniteQuery(peopleInfiniteQueryOptions(filters));
  void queryClient.prefetchQuery(templatesQueryOptions());
};

export const warmPerson: WarmUp = ({ queryClient, params }) => {
  void queryClient.prefetchQuery(personQueryOptions(params.userId));
  void queryClient.prefetchQuery(catalogueQueryOptions());
  void queryClient.prefetchQuery(templatesQueryOptions());
};

export const warmLibrary: WarmUp = ({ queryClient }) => {
  void queryClient.prefetchQuery(templatesQueryOptions());
  void queryClient.prefetchQuery(permissionTemplatesQueryOptions());
  void queryClient.prefetchQuery(catalogueQueryOptions());
};

export const warmPlants: WarmUp = ({ queryClient }) => {
  void queryClient.prefetchQuery(licencesQueryOptions());
};

export const warmPlantPeople: WarmUp = ({ queryClient, params, searchParams }) => {
  if (params.plantId === undefined) return;
  void queryClient.prefetchInfiniteQuery(peopleInfiniteQueryOptions(plantPeopleFiltersOf(searchParams.get('q') ?? '', params.plantId)));
  void queryClient.prefetchQuery(templatesQueryOptions());
};
